import PlusIcon from "assets/icon/PlusIcon";
import XIcon from "assets/icon/XIcon";
import SaveButton from "components/Button/SaveButton";
import { MainBodyCard, PagesTitle } from "components/Cards";
import { useModal } from "utils/context/ModalContext";
import { useEffect, useState } from "react";
import { BankBalanceService } from "services/BankBalanceService/BankBalanceService";
import { money } from "utils/helpers";

export default function PrimaryBankBalance() {
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchBankBalance } = BankBalanceService()

    const [currentSelectedBankBalance, setCurrentSelectedBankBalance] = useState(JSON.parse(localStorage.getItem('PrimaryBankBalance')) || [])
    const [bankBalance, setBankBalance] = useState([])
    const [bankBalanceFilterAccountName, setBankBalanceFilterAccountName] = useState('')

    const getBankBalance = async () => {
        const res = await fetchBankBalance()
        if (!res) return

        setBankBalance(res.data)
    }

    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            try {
                await getBankBalance()
            }
            finally {
                hideLoading()
            }
        }

        onLoad()
    }, [])

    return (
        <MainBodyCard>
            <PagesTitle title='Primary Bank Balance' />

            <div>
                <div className="p-2 shadow-md border rounded-xl bg-white">
                    <span className="font-semibold text-xl">Selected Primary Bank</span>

                    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-5 gap-2">
                        {bankBalance?.filter(item => currentSelectedBankBalance.includes(String(item.transferSourceId))).map((data, i) => {
                            return (
                                <div className="flex items-center bg-white rounded-lg shadow-md min-w-72 p-3 border" key={i}>
                                    <div className="flex-1 ">
                                        <div>
                                            <span className="text-sm">{ data.bankCode } - { data.accountName }</span>
                                        </div>
                                        <div>
                                            <span className="text-sm font-light">{ data.accountNo }</span>
                                        </div>
                                    </div>
                                    <div className="">
                                        <button
                                            className={`bg-slate-400 rounded-full p-1`}
                                            onClick={() => {
                                                const newValue = currentSelectedBankBalance.filter((item) => item !== String(data.transferSourceId))
                                                setCurrentSelectedBankBalance(newValue)                                      
                                            }}
                                        >
                                            <XIcon className="w-6 fill-white" />                               
                                        </button>                                
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <div className="mt-4">
                        <SaveButton 
                            onClick={() => {
                                localStorage.setItem('PrimaryBankBalance', JSON.stringify(currentSelectedBankBalance))
                                showSuccess()
                            }} 
                            visible={true} 
                        />
                    </div>
                </div>
            </div>
            
            <div className="mt-4">
                <span className="font-semibold text-xl">Available Bank Account</span>
            </div>

            <div className="my-2">
                <input className="input" value={bankBalanceFilterAccountName} onChange={(e) => setBankBalanceFilterAccountName(e.target.value)} placeholder="Account Name" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 3xl:grid-cols-5 gap-2">
                { bankBalance
                    ?.filter(item =>
                    item.accountName
                        ?.toLowerCase()
                        .includes(bankBalanceFilterAccountName.toLowerCase())
                    ).map((data, i) => {
                    return (
                        <div className="flex items-center bg-white rounded-lg shadow-md min-w-72 p-3" key={i}>
                            <div className="flex-1 ">
                                <div>
                                    <span className="text-sm">{ data.bankCode } - { data.accountName }</span>
                                </div>
                                <div>
                                    <span className="text-sm font-light">{ data.accountNo }</span>
                                </div>
                                <div className="">
                                    <span className="text-xl">Rp { money(data.balance) }</span>
                                </div>
                                <div className="flex gap-2 mt-2">
                                    
                                </div>
                            </div>
                            <div className="">
                                <button
                                    className={`${currentSelectedBankBalance.includes(String(data.transferSourceId)) ? 'bg-slate-400' : 'bg-black'} rounded-full p-1`}
                                    onClick={() => {
                                        if (currentSelectedBankBalance.includes(String(data.transferSourceId))) {
                                            const newValue = currentSelectedBankBalance.filter((item) => item !== String(data.transferSourceId))
                                            setCurrentSelectedBankBalance(newValue)
                                        } 
                                        else {
                                            setCurrentSelectedBankBalance([...currentSelectedBankBalance, String(data.transferSourceId)])
                                        }                                        
                                    }}
                                >
                                    {currentSelectedBankBalance.includes(String(data.transferSourceId)) ? 
                                        (<XIcon className="w-6 fill-white" />)
                                        :
                                        (<PlusIcon className="w-6 fill-white" />)                                        
                                    }                                    
                                </button>                                
                            </div>
                        </div>
                    )
                })}
                
            </div>
        </MainBodyCard>
    )
}